import "./css/global.scss";
import App from "./ts/App";
document.addEventListener("DOMContentLoaded", () => {
    const app = new App();
    app.init();
});
